import { getIdFromURL } from 'vue-youtube-embed';
import {DigitalSignagesTypes} from "@/enums/DigitalSignagesTypes";
import firebase from "firebase";
import moment from "moment/moment";
import {EventsTypes} from "@/enums/EventsTypes";
import {serializer} from "@/api/shared/serializer";
import {ContentStatus} from "@/enums/ContentStatus";
import {ContentTypes} from "@/enums/ContentTypes";
import { CustomContentMixin } from "@/mixins/CustomContent";
import {ResidentStatus} from "@/enums/ResidentStatus";
import {ResidentAccessesOnMyhub} from "@/enums/ResidentAccessesOnMyhub";
import Loader from "@/components/loader/Loader.vue";
import Handlebars from "handlebars";
import {PrintableCalendarFonts} from "@/consts/PrintableCalendarFonts";
import {OrientationTypes} from "@/enums/OrientationTypes";
import {DigitalSignageDateOptions} from "@/enums/DigitalSignageDateOptions";

export default {
    name: "CarouselDigitalSignage",
    mixins: [CustomContentMixin],
    components: {
        Loader,
    },
    props: {
        currentTimeAndDate: {
            type: String
        }
    },
    data() {
        return {
            promises: [],
            player: null,
            interval: 5000,
            reloadNextZero: false,
            isCycle: true,
            upcomingEventsToday: [],
            upcomingEventsTomorrow: [],
            onUpcomingEventsSubscribe: null,
            onUpcomingEventsWithWingsSubscribe: null,
            birthdays: [],
            intervalId: null,
            timer: 0,
            loading: true,
            whatsOnHeaders: [
                { text: this.$i18n.messages[this.$i18n.locale]['CarouselDigitalSignage.Event'], align: "start", value: "name" },
                { text: this.$i18n.messages[this.$i18n.locale]['GeneralTranslations.Description'], align: "start", value: "description" },
                { text: this.$i18n.messages[this.$i18n.locale]['CarouselDigitalSignage.StartTime'], value: "start", type: "Date" },
                { text: this.$i18n.messages[this.$i18n.locale]['CarouselDigitalSignage.Location'], value: "location" }
            ],
            contentCreatorPage: null,
            contentCreatorPages: [],
            selectedWings: [],
            eventsWithPictures: [],
            eventsImagesIndex: 0,
            eventImagesFontHeader: '',
            eventImagesFontBody: '',
            lastWeeksEvents: [
                { day: "Monday", events: [] },
                { day: "Tuesday", events: [] },
                { day: "Wednesday", events: [] },
                { day: "Thursday", events: [] },
                { day: "Friday", events: [] },
                { day: "Saturday", events: [] },
                { day: "Sunday", events: [] },
            ],
            activeItemIndex: 0,
            isReadyToWatch: false,
            isReadyToRender: false,
            currentDay: moment(new Date()).format("ddd"),
            currentTime: moment(new Date()).format(),
            intervalFuturePageId: null,
            settings: {
                isShowSidebar: this.digitalSignage?.isShowSidebar ?? false,
                isShowScreensaver: this.digitalSignage?.isShowScreensaver ?? false,
                backgroundScreensaver: this.digitalSignage?.backgroundScreensaver ?? '#ffffff',
                fontFamilyScreensaver: this.digitalSignage?.fontFamilyScreensaver ?? 'Roboto'
            },
            pagesData: [],
            loadedEventImages: []
        };
    },
    computed: {
        digitalSignageId() {
            return this.$route.params.id;
        },
        digitalSignage() {
            return this.$store.state.digitalSignageModule.currentDigitalSignage;
        },
        calenderEvents() {
            return this.$store.state.calenderModule.latestCalenderEvents.filter(x=>x.isPublished === true).slice(-4);
        },
        whatsOnToday() {
            return this.$store.state.calenderModule.todaysEvents.filter(x=>x.isPublished === true);
        },
        digitalSignageTypes() {
            return DigitalSignagesTypes;
        },
        facility() {
            return this.$store.state.facilityModule.selectedFacility;
        },
        facilityId() {
            return this.$route.params.facilityId ? this.$route.params.facilityId : this.$store.state.authModule.currentFacility;
        },
        contentCreatorList() {
            return this.$store.state.contentCreatorModule.content.filter((x) => {
                if(x.status === ContentStatus.Published && x.type === ContentTypes.DigitalSignagePage) {
                    return x;
                }
            })
        },
        eventWings() {
            return this.$store.state.eventLocationModule.eventWings;
        },
        isDigitalSignageChanges() {
            return this.$store.state.digitalSignageModule.digitalSignageChanges;
        },
        isContentCreatorChanges() {
            return this.$store.state.contentCreatorModule.creatorContentChanges;
        },
        DigitalSignageDateOptions() {
            return DigitalSignageDateOptions;
        },
    },
    async created() {
        window.addEventListener("beforeunload", this.unsubscribeCurrentDigitalSignage);
        window.addEventListener("unload", this.unsubscribeCurrentDigitalSignage);
        await this.$store.dispatch("getDigitalSignage", this.digitalSignageId);
        this.$store.dispatch("subscribeDigitalSignage", this.digitalSignageId);
        await this.$store.dispatch("getEventWings");
        await this.getDigitalSignageWings();
        await this.getDataDigitalSignage();
        await this.checkContentCreator();
        await this.handleTwoEventImagesMode();
        this.loadedEventImages = this.eventsImages()[this.eventsImagesIndex]?.galleryPhotos.map(() => false);
        this.setStyles();
        this.intervalFuturePageId = setInterval(this.initIntervalForOtherPages, 10000);
        this.checkLastSocialEvents();
        this.checkWhatsOnToday();
        this.checkYoutubeVideo();
        this.isReadyToRender = true;
        this.isReadyToWatch = true;
        this.loading = false;
    },
    watch: {
        async isDigitalSignageChanges(newData) {
            if(this.isReadyToWatch) {
                // this.timer = 0;
                clearInterval(this.intervalId);
                await this.$store.dispatch("getCreatorContent");
                await this.getDigitalSignageWings();
                await this.getDataDigitalSignage();
                this.setStyles();
                this.$emit("updateSidebar", this.settings);
                this.contentCreatorPages = [];
                await this.checkContentCreator();
                this.checkOnlineStatusToDigitalSignage();
                this.$forceUpdate();
            }
        },
        async isContentCreatorChanges(newData) {
            if(this.isReadyToWatch) {
                // this.timer = 0;
                clearInterval(this.intervalId);
                await this.$store.dispatch("getCreatorContent");
                this.contentCreatorPages = [];
                await this.checkContentCreator();
                this.$forceUpdate();
            }
        },
        async pages(newValue, oldValue) {
            if(newValue.length === 1 && newValue[0].displayDate && newValue[0].displayOn === this.DigitalSignageDateOptions.Custom) {
                const now = moment();
                const targetTime = moment(newValue[0].time.end, "hh:mm A");
                const targetMoment = moment().hour(targetTime.hour()).minute(targetTime.minute()).second(0).millisecond(0);
                const millisecondsUntilTarget = targetMoment.diff(now);

                setTimeout(() => {
                    if(this.pages()[0]) {
                        this.initIntervalForOtherPages();
                        this.pages()[0].enabled = false;
                    }
                }, millisecondsUntilTarget);
            }

            if(oldValue.length <= 1 && newValue.length >= 2) {
                this.isCycle = false;
                this.$nextTick(() => {
                    this.isCycle = true;
                });
            }

            if(newValue.length !== oldValue.length) {

                if(newValue.length > oldValue.length) {
                    let newIndex;

                    for (let i = 0; i < newValue.length; i++) {
                        const newItem = newValue[i];
                        const isItemInOldArray = oldValue.some(oldItem => oldItem.name === newItem.name);
                        if (!isItemInOldArray) {
                            newIndex = i;
                        }
                    }

                    if(this.activeItemIndex === newIndex) {
                        this.activeItemIndex = this.activeItemIndex + 1;
                    }
                }

                if(newValue[this.activeItemIndex]?.type === this.digitalSignageTypes.YouTubeVideo || newValue?.find(x => x?.type === this.digitalSignageTypes.YouTubeVideo)) {
                    this.player = null;
                    this.setYouTubePlayer();
                } else {
                    this.player = null;
                }
            }

            this.pagesData = this.pages().map(page => ({
                ...page,
                hasData: true,
                orientation: page.orientation,
                CCHtml: null
            }));

            this.checkUpcomingEvents();
            this.checkLastWeeksEvents();
            this.checkLastSocialEvents();
            this.checkBirthdays();
            this.checkEventImages();
            this.checkCustomContent();
            this.checkWhatsOnToday();
            this.checkYoutubeVideo();
            await this.checkContentCreator();
            this.activeItemIndex = 0;
        },
        upcomingEventsToday() {
            this.checkUpcomingEvents();
        },
        upcomingEventsTomorrow() {
            this.checkUpcomingEvents();
        },
        lastWeeksEvents() {
            this.checkLastWeeksEvents();
        },
        calenderEvents(newVal, oldVal) {
            this.checkLastSocialEvents();
        },
        birthdays() {
            this.checkBirthdays();
        },
        eventsWithPictures() {
            this.checkEventImages();
        },
        whatsOnToday() {
            this.checkWhatsOnToday();
        }
    },
    methods: {
        pages() {
            return this.$store.state.digitalSignageModule.currentDigitalSignage.pages.filter(x=> x.enabled === true && this.isValidDisplayTime(x))
        },
        checkUpcomingEvents() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === this.digitalSignageTypes.UpcomingEvents){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.upcomingEventsToday.length > 0 || this.upcomingEventsTomorrow.length > 0
                    };
                }
            }
        },
        checkLastWeeksEvents() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === this.digitalSignageTypes.LastWeeksEvents){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.lastWeeksEvents.some(day => day.events.length > 0)
                    };
                }
            }
        },
        checkLastSocialEvents() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === this.digitalSignageTypes.LastSocialEvents){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.calenderEvents?.length > 0
                    };
                }
            }
        },
        checkBirthdays() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === this.digitalSignageTypes.Birthdays){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.birthdays?.length > 0
                    };
                }
            }
        },
        checkEventImages() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === this.digitalSignageTypes.EventImages){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.eventsWithPictures.length > 0
                    };
                }
            }
        },
        checkCustomContent() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === 'Custom Content'){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.page.content
                    };
                }
            }
        },
        checkWhatsOnToday() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === 'Whats On Today'){
                    this.pagesData[index] = {
                        ...page,
                        hasData: this.whatsOnToday.length > 0
                    };
                }
            }
        },
        checkYoutubeVideo() {
            for (const [index, page] of this.pages().entries()){
                if (page.type === this.digitalSignageTypes.YouTubeVideo){
                    this.pagesData[index] = {
                        ...page,
                        hasData: page?.url.length > 0
                    };
                }
            }
        },
        async checkContentCreator() {
            for (const [index, page] of this.pages().entries()) {
                if (page.type === this.digitalSignageTypes.ContentCreator) {
                    this.pagesData[index] = {
                        ...page
                    }

                    if (this.contentCreatorList.find(x => x.id === page.contentCreatorId)) {
                        const contentCreatorPage = this.contentCreatorList.find(x => x.id === page.contentCreatorId);

                        const contentHtml = contentCreatorPage.html;
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(contentHtml, 'text/html');
                        await this.getData(contentHtml);

                        const sections = doc.querySelectorAll('div.is-section');
                        let removedSectionsCount = 0;

                        sections.forEach(section => {
                            const containers = section.querySelectorAll('.is-container');
                            const backgroundImage = section.querySelector('.is-overlay-bg');

                            containers.forEach(container => {
                                if (container) {
                                    const widgets = container.querySelectorAll(':scope > div');

                                    widgets.forEach(widget => {
                                        if (widget.id === 'LastWeeksEvents') {
                                            if (!this.dataCustomContent.lastWeekEvents.some(day => day.events.length)) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.id === 'ThisWeeksBirthday') {
                                            if (!this.dataCustomContent.weeksBirthday?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.id === 'UpcomingEvents') {
                                            if (!this.dataCustomContent.events?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.querySelector('#MonthlyCalendar')) {
                                            if (!this.dataCustomContent.monthlyCalendar?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.querySelector('#WeeklyCalendar')) {
                                            if (!this.dataCustomContent.weeklyCalendar.Sun?.length &&
                                              !this.dataCustomContent.weeklyCalendar.Mon?.length &&
                                              !this.dataCustomContent.weeklyCalendar.Tue?.length &&
                                              !this.dataCustomContent.weeklyCalendar.Wed?.length &&
                                              !this.dataCustomContent.weeklyCalendar.Thu?.length &&
                                              !this.dataCustomContent.weeklyCalendar.Fri?.length &&
                                              !this.dataCustomContent.weeklyCalendar.Sat?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.querySelector('#DailyCalendar')) {
                                            if (!this.dataCustomContent.dailyCalendar.events?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.id === 'Menu') {
                                            if (!this.dataCustomContent.menu.Breakfast?.length &&
                                              !this.dataCustomContent.menu.Dinner?.length &&
                                              !this.dataCustomContent.menu.Lunch?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.id === 'Breakfast') {
                                            if (!this.dataCustomContent.breakfast?.length ||
                                              !this.dataCustomContent.breakfast?.meals?.length ||
                                              !this.dataCustomContent.breakfast?.meals?.plates?.length ||
                                              !this.dataCustomContent.breakfast?.meals?.plates?.recipes?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.id === 'Lunch') {
                                            if (!this.dataCustomContent.lunch?.length ||
                                              !this.dataCustomContent.lunch?.meals?.length ||
                                              !this.dataCustomContent.lunch?.meals?.plates?.length ||
                                              !this.dataCustomContent.lunch?.meals?.plates?.recipes?.length) {
                                                widget.remove();
                                            }
                                        }
                                        if (widget.id === 'Dinner') {
                                            if (!this.dataCustomContent.dinner?.length ||
                                              !this.dataCustomContent.dinner?.meals?.length ||
                                              !this.dataCustomContent.dinner?.meals?.plates?.length ||
                                              !this.dataCustomContent.dinner?.meals?.plates?.recipes?.length) {
                                                widget.remove();
                                            }
                                        }
                                    });

                                    if (!container.querySelector('div') && !backgroundImage) {
                                        container.remove();
                                    }
                                }
                            });


                            if (!section.querySelector('.is-container')) {
                                removedSectionsCount++;
                                section.remove();
                            }
                        });

                        const stringHtml = `${doc.body.innerHTML} ${contentCreatorPage?.sectionCss}`;
                        const Handlebars = require('handlebars');
                        let generatedHtml: any = null;

                        if(stringHtml) {
                            const compiledTemplate = Handlebars.compile(stringHtml);
                            await this.getData(stringHtml);
                            generatedHtml = compiledTemplate(this.dataCustomContent);
                        }

                        if (removedSectionsCount === sections.length) {
                            this.pagesData[index].hasData = false;
                            this.pagesData[index].CCHtml = null;
                        }
                        else {
                            this.pagesData[index].hasData = true;
                            this.pagesData[index].CCHtml = generatedHtml;
                        }
                    }
                    else {
                        this.pagesData[index].hasData = false;
                        this.pagesData[index].CCHtml = null;
                    }
                }
            }
        },
        async getDataDigitalSignage() {
            this.promises = [];
            if(this.digitalSignage.pages.find(x => x.type === this.digitalSignageTypes.ContentCreator)) {
                this.promises.push(
                  this.$store.dispatch("subscribeContentByDigitalSignage", this.digitalSignage),
                  await this.$store.dispatch("getCreatorContent"),
                )
            }

            if(this.digitalSignage.pages.find(x => x.type === this.digitalSignageTypes.LastSocialEvents)) {
                this.promises.push(this.$store.dispatch("getLatestCalenderEvents", {
                    limit: 4,
                    facilityId: this.facilityId,
                    selectedWings: this.selectedWings
                }))
            }

            if(this.digitalSignage.pages.find(x => x.type === 'Whats On Today')) {
                this.promises.push(this.$store.dispatch("getTodaysEvents", {
                    limit: 5,
                    facilityId: this.facilityId,
                }))
            }

            if(this.digitalSignage.pages.find(x => x.type === this.digitalSignageTypes.LastWeeksEvents)) {
                this.promises.push(await this.getLastWeeksEvents())
            }

            if(this.digitalSignage.pages.find(x => x.type === this.digitalSignageTypes.UpcomingEvents)) {
                this.promises.push(this.getUpcomingEvents())
            }

            if(this.digitalSignage.pages.find(x => x.type === this.digitalSignageTypes.Birthdays)) {
                this.promises.push(this.getResidentWithUpcomingBirthdays())
            }

            if(this.digitalSignage.pages.find(x => x.type === this.digitalSignageTypes.EventImages)) {
                this.promises.push(this.getEventsWithPictures())
            }

            return Promise.all(this.promises).then(() => {
                this.checkEventImagesFonts()
                this.startTimer();
                this.$forceUpdate();
            }).then(() => {
                this.pagesData = []
                this.$forceUpdate();
                this.checkFirstSlide();
                this.checkUpcomingEvents();
                this.checkLastWeeksEvents();
                this.checkLastSocialEvents();
                this.checkBirthdays();
                this.checkEventImages();
                this.checkCustomContent();
                this.checkWhatsOnToday();
                this.checkYoutubeVideo()
                this.$forceUpdate();
            })
        },
        isContentPortraitOrientation(index) {
            return this.pagesData[index]?.orientation === OrientationTypes.Portrait;
        },
        getVideoId(url){
            return getIdFromURL(url)
        },
        modifyUrl(url) {
            if(!url) return '';

            let endpoint = url;
            endpoint = endpoint.replace("oembed", 'iframe width="1000" height="500"');
            endpoint = endpoint.replace("url", "src");
            endpoint = endpoint.replace("watch?v=", "embed/");
            endpoint = endpoint.replace("oembed", "iframe");
            endpoint = endpoint.replace(
              '"></iframe',
              '?rel=0&enablejsapi=1&autoplay=1&controls=0&showinfo=0&loop=1&iv_load_policy=3&mute=1" volume="0"></iframe'
            );
            return endpoint;
        },
        play() {
            setTimeout(() => {
                if(this.player) {
                    this.player.playVideo();
                }
            }, 200)
        },
        stop() {
            if(this.player && this.player.stopVideo) {
                this.player.stopVideo();
            }
        },
        ready() {
            this.setYouTubePlayer();
        },
        startTimer() {
            this.intervalId = setInterval(() => {
                this.timer++;
            }, 1000)
        },
        isTomorrowEvents(page) {
            if(page.timeInSeconds < this.timer) {
                this.timer = 0;
            }
            if (this.upcomingEventsToday.length > 0 && this.upcomingEventsTomorrow.length > 0) {
                return (page.timeInSeconds / 2) < this.timer; // if we got both types of events, show for half-time each

            }
            else {
                return this.upcomingEventsTomorrow.length > 0; // if only one type of events, show only the full one
            }

        },
        onSlideChange(slideNumber) {
            this.interval = this.pages()[slideNumber]?.timeInSeconds * 1000;
            this.timer = 0;

            if(slideNumber == 1)
                this.reloadNextZero = true

            if(slideNumber == 0 && this.reloadNextZero == true)
                this.$forceUpdate();

            if(this.pages()[slideNumber]?.type === this.digitalSignageTypes.YouTubeVideo) {
                this.stop();
                setTimeout(() => {
                    this.setYouTubePlayer();
                }, 400)
            }

            if(this.pages()[slideNumber]?.type !== this.digitalSignageTypes.YouTubeVideo)
                this.stop();

            if(this.pages()[slideNumber]?.type === this.digitalSignageTypes.EventImages)
                this.eventsImagesIndex = 0;

            if (!this.isValidDisplayTime(this.pages()[slideNumber])) {
                if (this.pages()[slideNumber]){
                    this.pages()[slideNumber].enabled = false;
                }
                this.$refs.carouselRef.next();
            }
        },
        eventImagesSlideChanges() {
            this.loadedEventImages = this.eventsImages()[this.eventsImagesIndex].galleryPhotos.map(() => false);
        },
        setYouTubePlayer() {
            this.player = this.$refs.youtubePlayer?.find(x => x.$el._prevClass.includes('active-player'))?.player;
            this.play();
        },
        checkFirstSlide() {
            const firstPage = this.pages()[0];
            if(firstPage && this.activeItemIndex === 0) {
                this.interval = firstPage.timeInSeconds * 1000;

                if(firstPage.type === this.digitalSignageTypes.YouTubeVideo) {
                    setTimeout(() => {
                        this.setYouTubePlayer();
                    }, 1000)
                }

                if (!this.isValidDisplayTime(firstPage)) {
                    this.$refs.carouselRef.next();
                }
            }
        },
        isValidDisplayTime(page) {
            if(!page?.enabled) {
                return false;
            }

            if(!page?.displayDate) {
                return true;
            }

            if (page?.displayDate && page?.displayOn === this.DigitalSignageDateOptions.Custom) {
                if (!page?.displayForDays?.length) {
                    return false;
                }

                if (page?.displayForDays && page?.displayForDays?.length && !page?.displayForDays?.includes(this.currentDay)) {
                    return false;
                } else {
                    if (page?.time && page?.time?.start && page?.time?.end) {
                        const startTime = moment(page.time.start, "hh:mm A");
                        const endTime = moment(page.time.end, "hh:mm A");
                        const currentTime = moment();

                        if (!currentTime.isBetween(startTime, endTime, null, '[]')) {
                            return false;
                        } else {
                            return true;
                        }
                    }
                }
            }

            if(page?.displayOn === this.DigitalSignageDateOptions.AllTheTime) {
                return true;
            }

            return false;
        },
        getDigitalSignageWings() {
            if(this.digitalSignage?.hasOwnProperty('selectedWings') && this.digitalSignage?.selectedWings.length) {
                this.selectedWings = [...this.digitalSignage?.selectedWings]
            } else {
                this.selectedWings = [...this.eventWings.map(x => x.id)]
            }
        },
        async getUpcomingEvents() {
            if(this.selectedWings.length > 10) {
                const result = [];

                for (let i = 0; i < this.selectedWings.length; i += 10) {
                    result.push(this.selectedWings.slice(i, i + 10));
                }

                for (let i = 0; i < result.length; i++) {
                    await this.subscribeOnUpcomingEvents(result[i])
                }

            } else {
                await this.subscribeOnUpcomingEvents(this.selectedWings)
            }
        },
        async subscribeOnUpcomingEvents(selectedWings) {
            const fromDate = moment(new Date()).toDate();
            const toDate = moment(new Date()).add(1, "day").hour(23).minute(59).second(59).toDate();

            const eventsUpcomingQuery = await firebase
              .firestore()
              .collection("calender")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("isPublished", "==", true)
              .where("start", ">=", fromDate)
              .where("start", "<=", toDate)
              .where("wingsIds", "array-contains-any", selectedWings);

            const eventsUpcomingWithEmptyWingsQuery = await firebase
              .firestore()
              .collection("calender")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("isPublished", "==", true)
              .where("start", ">=", fromDate)
              .where("start", "<=", toDate)
              .where("wingsIds", "==", []);

            const eventsWithWingsPromise = new Promise((resolve) => {
                eventsUpcomingQuery
                  .onSnapshot((snapshot) => {
                      this.setUpcomingEvents(serializer.querySnapshotToDocuments(snapshot), 'withWingsIds')
                      resolve();
                  })
            })

            const eventsWithoutWingsPromise = new Promise((resolve) => {
                eventsUpcomingWithEmptyWingsQuery
                  .onSnapshot((snapshot) => {
                      this.setUpcomingEvents(serializer.querySnapshotToDocuments(snapshot), 'withoutWingsIds')
                      resolve();
                  });
            });

            return Promise.all([eventsWithWingsPromise, eventsWithoutWingsPromise]);
        },
        async setUpcomingEvents(data, key) {
            let resList: Array<any> = [];
            const stateData: any = [...this.upcomingEventsToday, ...this.upcomingEventsTomorrow];

            if(data && data.length) {
                if(!stateData.length) {
                    resList = data;
                } else {
                    for (let i = 0; i < stateData.length; i++) {
                        const object = stateData[i];
                        if (data.every(x => x.wingsIds && x.wingsIds.length)) {
                            if (object.wingsIds && object.wingsIds.length && !data.some(element => element.id === object.id)) {
                                stateData.splice(i, 1);
                                i--;
                            }
                        } else {
                            if (object.wingsIds && !object.wingsIds.length && !data.some(element => element.id === object.id)) {
                                stateData.splice(i, 1);
                                i--;
                            }
                        }
                    }

                    const uniqueIds = new Set();
                    resList = [...stateData, ...data].filter(obj => {
                        if (!uniqueIds.has(obj.id)) {
                            uniqueIds.add(obj.id);
                            return true;
                        }
                        return false;
                    });
                }

                this.upcomingEventsToday = [];
                this.upcomingEventsTomorrow = [];

                resList.forEach((event: any) => {
                    const start = moment(event.start.seconds ? event.start.seconds * 1000 : event.start).format('YYYY-MM-DD');
                    const current = moment(new Date()).format('YYYY-MM-DD');
                    event.start = moment(event.start.seconds ? event.start.seconds * 1000 : event.start).toDate();

                    if(start === current) {
                        if(!this.upcomingEventsToday.find(x => x.id === event.id)) {
                            this.upcomingEventsToday.push(event);
                        }
                    } else {
                        if(!this.upcomingEventsTomorrow.find(x => x.id === event.id)) {
                            this.upcomingEventsTomorrow.push(event);
                        }
                    }
                });

                this.upcomingEventsToday = this.upcomingEventsToday.sort((a: any, b: any) => moment(a.start).diff(moment(b.start)));
                this.upcomingEventsTomorrow = this.upcomingEventsTomorrow.sort((a: any, b: any) => moment(a.start).diff(moment(b.start)));
            } else {
                if(key === "withWingsIds") {
                    this.upcomingEventsToday = this.upcomingEventsToday.filter(x => x.wingsIds && !x.wingsIds.length);
                    this.upcomingEventsTomorrow = this.upcomingEventsTomorrow.filter(x => x.wingsIds && !x.wingsIds.length);
                }

                if(key === "withoutWingsIds") {
                    this.upcomingEventsToday = this.upcomingEventsToday.filter(x => x.wingsIds && x.wingsIds.length);
                    this.upcomingEventsTomorrow = this.upcomingEventsTomorrow.filter(x => x.wingsIds && x.wingsIds.length);
                }
            }
        },
        async getResidentWithUpcomingBirthdays() {
            const today = moment(new Date()).format("MMM-DD");

            await firebase
              .firestore()
              .collection("residents")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("status","==", ResidentStatus.ActiveResident)
              .where("shortDob", '==', today)
              .get()
              .then((querySnapshots) => {
                  const data = serializer.querySnapshotToDocuments(querySnapshots);
                  const res = [];

                  data.forEach((doc: any) => {
                      const isShow = doc.accessesOnMyhub.find(x => x.name === ResidentAccessesOnMyhub.DisplayBirthday)?.isEnabled;

                      if(isShow) {
                          doc.dateOfBirth = moment(doc.dateOfBirth.seconds * 1000).toDate()
                          res.push(doc);
                      }
                  });

                    this.birthdays = res;
                })
        },
        unsubscribeCurrentDigitalSignage() {
            if(this.$store.state.digitalSignageModule.subscribeCurrentDigitalSignage) {
                this.$store.state.digitalSignageModule.subscribeCurrentDigitalSignage()

                this.$store.dispatch("setOnlineStatusToDigitalSignage", {
                    id: this.digitalSignageId ?? this.digitalSignage?.id,
                    isOnline: false
                });
            }
        },
        async getEventsWithPictures() {
            const startDate = moment().subtract(3, 'week').toISOString().substring(0, 10);
            const endDate = moment().toISOString().substring(0, 10);
            const fromDate = moment(startDate).startOf('day').toDate()
            const toDate = moment(endDate).endOf("day").toDate()

            await firebase
                .firestore()
                .collection("calender")
                .where("facilityId", "==", this.facility.id)
                .where("isPublished", "==", true)
                .where("start", ">=", fromDate)
                .where("start", "<=", toDate)
                .where("type", "in", [EventsTypes.ConciergeRequest, EventsTypes.Concierge, EventsTypes.PremiumServices, EventsTypes.LifestylePrograms])
                .get()
                .then((querySnapshot) => {
                    let events = serializer.querySnapshotToDocuments(querySnapshot);

                    events = events.filter((x: any) => {
                       if(x?.galleryPhotos && x?.galleryPhotos.length >= 1 && !x?.galleryPhotos.find(photo => photo?.videoUrl)) {
                           return x;
                       }
                    })

                    events = events.filter((x: any) => (x?.wingsIds && x?.wingsIds.length && x?.wingsIds.some(id => this.selectedWings.includes(id)) || (x?.wingsIds && !x?.wingsIds.length)))

                    events = events.sort((a: any, b: any) => moment(b.start.seconds * 1000).diff(moment(a.start.seconds * 1000)));

                    // if event has more than 6 images split it
                    this.eventsWithPictures = events.slice(0, 4).flatMap((x: any) => {
                        const chunkedGalleryPhotos = [];
                        for (let i = 0; i < x.galleryPhotos.length; i += 6) {
                            const galleryChunk = x.galleryPhotos.slice(i, i + 6);
                            chunkedGalleryPhotos.push({
                                id: x.id,
                                name: x.name,
                                time: moment(x.start.seconds * 1000).format("dddd, MMMM Do, YYYY - hh:mm A"),
                                galleryPhotos: galleryChunk.map((item, index) => {
                                    return {
                                        ...item,
                                        isWidthCalculated: false,
                                        calculatedWidth: null,
                                        isPortrait: false
                                    }
                                }),
                                imageUrl: x.imageUrl,
                                description: x.description,
                                location: x.location
                            });
                        }

                        return chunkedGalleryPhotos;
                    });
                })

            for (const [eventIndex, event] of this.eventsWithPictures.entries()) {
                for (const [photoIndex, photo] of event.galleryPhotos.entries()) {
                    const isPortrait = await this.isImagePortrait(photo.photoUrl);
                    this.eventsWithPictures[eventIndex].galleryPhotos[photoIndex] = {
                        ...this.eventsWithPictures[eventIndex].galleryPhotos[photoIndex],
                        isPortrait: isPortrait
                    };
                }
            }
        },
        eventsImages() {
            return this.eventsWithPictures.map((item, index) => {
                return {
                    ...item,
                    index: index + 1,
                }
            });
        },
        isHideBackground(imageUrl) {
            if(imageUrl.includes("no-image")) {
                return false;
            }

            return true;
        },
        checkEventImagesFonts() {
            this.eventImagesFontHeader = this.facility?.printableCalendarHeaderFont || PrintableCalendarFonts.MrsEavesMedium;
            this.eventImagesFontBody = this.facility?.printableCalendarBodyFont || PrintableCalendarFonts.ProximaNovaRegular;
        },
        async getLastWeeksEvents() {
            if(this.selectedWings.length > 10) {
                const result = [];

                for (let i = 0; i < this.selectedWings.length; i += 10) {
                    result.push(this.selectedWings.slice(i, i + 10));
                }

                for (let i = 0; i < result.length; i++) {
                    await this.getLastWeeksEventsByWings(result[i])
                }

            } else {
                await this.getLastWeeksEventsByWings(this.selectedWings)
            }
        },
        async getLastWeeksEventsByWings(selectedWings) {
            const fromDate = moment(new Date()).subtract(1, "week").startOf('isoWeek').toDate();
            const toDate =  moment(new Date()).subtract(1, "week").endOf('isoWeek').toDate();
            const resList: Array<any> = [];

            await firebase
              .firestore()
              .collection("calender")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("isPublished", "==", true)
              .where("start", ">=", fromDate)
              .where("start", "<=", toDate)
              .where("wingsIds", "array-contains-any", selectedWings)
              .where("isDisplayInWeekSummary", "==", true)
              .get()
              .then((querySnapshot) => {
                  resList.push(...serializer.querySnapshotToDocuments(querySnapshot));
              });

            await firebase
              .firestore()
              .collection("calender")
              .where("facilityId", "==", this.$store.state.authModule.currentFacility)
              .where("isPublished", "==", true)
              .where("start", ">=", fromDate)
              .where("start", "<=", toDate)
              .where("wingsIds", "==", [])
              .where("isDisplayInWeekSummary", "==", true)
              .get()
              .then((querySnapshot) => {
                  resList.push(...serializer.querySnapshotToDocuments(querySnapshot));
              });

            resList.forEach((event: any) => {
                const day = moment(event.start.seconds * 1000).format('dddd');
                event.start = moment(event.start.seconds * 1000).toDate();

                if(!this.lastWeeksEvents.find(x => x.day === day).events.some(x => x.id === event.id)) {
                    this.lastWeeksEvents.find(x => x.day === day).events.push(event);
                }
            })
        },
        unsubscribeUpcomingEvents() {
            if(this.onUpcomingEventsSubscribe) {
                this.onUpcomingEventsSubscribe();
            }
            if(this.onUpcomingEventsWithWingsSubscribe) {
                this.onUpcomingEventsWithWingsSubscribe();
            }
        },
        unsubscribeLast4SocialEvents() {
            if(this.$store.state.calenderModule.onLatestCalenderEventsUnsubscribe) {
                this.$store.state.calenderModule.onLatestCalenderEventsUnsubscribe()
            }
            if(this.$store.state.calenderModule.onLatestCalenderEventsWithWingsUnsubscribe) {
                this.$store.state.calenderModule.onLatestCalenderEventsWithWingsUnsubscribe()
            }
        },
        async initIntervalForOtherPages() {
            if(this.digitalSignage && this.digitalSignage?.pages && this.digitalSignage?.pages?.length) {
                for(let i = 0; i < this.digitalSignage.pages.length; i++) {
                    const page = this.digitalSignage.pages[i];
                    if(this.isValidDisplayTime(page) && !this.pages().some(item => Object.keys(page).every(key => item[key] === page[key]))) {
                        await this.getDataDigitalSignage();
                    }
                }
            }
        },
        setStyles() {
            this.settings.isShowSidebar = this.digitalSignage?.isShowSidebar ?? false;
            this.settings.isShowScreensaver = this.digitalSignage?.isShowScreensaver ?? false;
            this.settings.backgroundScreensaver = this.digitalSignage?.backgroundScreensaver ?? '#ffffff';
            this.settings.fontFamilyScreensaver = this.digitalSignage?.fontFamilyScreensaver ?? 'Roboto';
        },
        removeSection(doc: Document, sectionId: string): string {
            const targetElement = doc.querySelector(sectionId);
            if (targetElement) {
                let parentElement = targetElement.parentElement;
                while (parentElement && !parentElement.classList.contains('is-section')) {
                    parentElement = parentElement.parentElement;
                }
                if (parentElement) {
                    parentElement.remove();
                }
            }

            return doc.body.innerHTML;
        },
        checkOnlineStatusToDigitalSignage() {
            if(this.digitalSignage?.hasOwnProperty('isOnline') && this.digitalSignage.isOnline === false) {
                this.$store.dispatch("setOnlineStatusToDigitalSignage", {
                    id: this.digitalSignageId,
                    isOnline: true
                });
            }
        },
        dynamicClass(index) {
            const length = this.eventsImages()[index]?.galleryPhotos.length;
            const classes = {
                1: () => {
                    return 'one-image'
                },
                2: () => {
                    const isFirstImagePortrait = this.eventsImages()[index]?.galleryPhotos[0].isPortrait;
                    const isSecondImagePortrait = this.eventsImages()[index]?.galleryPhotos[1].isPortrait;

                    if (!isFirstImagePortrait && !isSecondImagePortrait) {
                        return 'two-images-hor d-flex flex-column align-items-center';
                    } else if (isFirstImagePortrait && isSecondImagePortrait) {
                        return 'two-images-portrait d-flex flex-column align-items-center';
                    } else if (!(isFirstImagePortrait && isSecondImagePortrait)) {
                        return 'two-images-portrait d-flex flex-column align-items-center';
                    } else if (this.isHiddenLocationPanel(index)) {
                        return 'two-images-hor d-flex flex-column';
                    } else {
                        return 'two-images';
                    }
                },
                3: () => {
                    return 'three-images'
                },
                4: () => {
                    return 'four-images'
                },
                5: () => {
                    return 'five-images'
                },
                6: () => {
                    return 'six-images'
                },
            };

            return classes[length] ? classes[length]() : '';
        },
        isHiddenLocationPanel(pageIndex) {
            return !(!!(this.eventsImages()[pageIndex].description) || !!(this.eventsImages()[pageIndex].location))
        },
        onImageLoad(index) {
            this.$set(this.loadedEventImages, index, true);
        },
        isImagePortrait(url) {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = url;

                img.onload = () => {
                    resolve(img.width <= img.height);
                    img.onload = null;
                    img.onerror = null;
                };

                img.onerror = () => {
                    reject('Image failed to load. Please check the URL.');
                    img.onload = null;
                    img.onerror = null;
                };
            });
        },
        handleTwoEventImagesMode() {
            this.eventsWithPictures.forEach((event, index) => {
                if (event?.galleryPhotos.length === 2) {
                    this.getResponsiveImageSize(event?.galleryPhotos[0].photoUrl)
                      .then(firstCalcWidth => {
                          this.eventsWithPictures[index].galleryPhotos[0].isWidthCalculated = true;
                          this.eventsWithPictures[index].galleryPhotos[0].calculatedWidth = firstCalcWidth + 'px';

                          return this.getResponsiveImageSize(event?.galleryPhotos[1].photoUrl);
                      })
                      .then(secondCalcWidth => {
                          this.eventsWithPictures[index].galleryPhotos[1].isWidthCalculated = true;
                          this.eventsWithPictures[index].galleryPhotos[1].calculatedWidth = secondCalcWidth + 'px';
                      })
                      .catch(error => {
                          console.error('Error:', error);
                          console.error('Event:', event);
                      });
                }
            });
        },
        getResponsiveImageSize(imgUrl){
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = imgUrl;

                img.onload = () => {
                    const height = (window.innerHeight * 0.8) - 80;
                    const width = height * (img.width / img.height);
                    resolve(width);
                    img.onload = null;
                    img.onerror = null;
                };

                img.onerror = () => {
                    reject(new Error('Image failed to load. Please check the URL.'));
                    img.onload = null;
                    img.onerror = null;
                };
            });
        }
    },
    beforeDestroy() {
        this.unsubscribeCurrentDigitalSignage();
        this.unsubscribeUpcomingEvents();
        this.unsubscribeLast4SocialEvents();
    },
    beforeRouteLeave(to, from, next) {
        this.unsubscribeCurrentDigitalSignage();
        this.unsubscribeUpcomingEvents();
        this.unsubscribeLast4SocialEvents();
        next();
    }
};